// Spacing Style Plugin (Margin & Padding)
import { createSimpleProperty } from './helpers.js';

export default {
    id: 'spacing',
    label: 'Spacing',
    icon: 'Move',
    properties: {
        padding: {
            label: 'Padding',
            type: 'select',
            options: ['0', 'px', '0.5', '1', '1.5', '2', '2.5', '3', '3.5', '4', '5', '6', '7', '8', '9', '10', '11', '12', '14', '16', '20', '24', '28', '32', '36', '40', '44', '48', '52', '56', '60', '64', '72', '80', '96'],
            default: '4',
            ...createSimpleProperty('p')
        },
        paddingX: {
            label: 'Padding X',
            type: 'select',
            options: ['0', 'px', '0.5', '1', '1.5', '2', '2.5', '3', '3.5', '4', '5', '6', '7', '8', '9', '10', '11', '12', '14', '16', '20', '24', '28', '32', '36', '40', '44', '48', '52', '56', '60', '64', '72', '80', '96'],
            default: null,
            ...createSimpleProperty('px')
        },
        paddingY: {
            label: 'Padding Y',
            type: 'select',
            options: ['0', 'px', '0.5', '1', '1.5', '2', '2.5', '3', '3.5', '4', '5', '6', '7', '8', '9', '10', '11', '12', '14', '16', '20', '24', '28', '32', '36', '40', '44', '48', '52', '56', '60', '64', '72', '80', '96'],
            default: null,
            ...createSimpleProperty('py')
        },
        paddingTop: {
            label: 'Padding Top',
            type: 'select',
            options: ['0', 'px', '0.5', '1', '1.5', '2', '2.5', '3', '3.5', '4', '5', '6', '7', '8', '9', '10', '11', '12', '14', '16', '20', '24', '28', '32', '36', '40', '44', '48', '52', '56', '60', '64', '72', '80', '96'],
            default: null,
            ...createSimpleProperty('pt')
        },
        paddingRight: {
            label: 'Padding Right',
            type: 'select',
            options: ['0', 'px', '0.5', '1', '1.5', '2', '2.5', '3', '3.5', '4', '5', '6', '7', '8', '9', '10', '11', '12', '14', '16', '20', '24', '28', '32', '36', '40', '44', '48', '52', '56', '60', '64', '72', '80', '96'],
            default: null,
            ...createSimpleProperty('pr')
        },
        paddingBottom: {
            label: 'Padding Bottom',
            type: 'select',
            options: ['0', 'px', '0.5', '1', '1.5', '2', '2.5', '3', '3.5', '4', '5', '6', '7', '8', '9', '10', '11', '12', '14', '16', '20', '24', '28', '32', '36', '40', '44', '48', '52', '56', '60', '64', '72', '80', '96'],
            default: null,
            ...createSimpleProperty('pb')
        },
        paddingLeft: {
            label: 'Padding Left',
            type: 'select',
            options: ['0', 'px', '0.5', '1', '1.5', '2', '2.5', '3', '3.5', '4', '5', '6', '7', '8', '9', '10', '11', '12', '14', '16', '20', '24', '28', '32', '36', '40', '44', '48', '52', '56', '60', '64', '72', '80', '96'],
            default: null,
            ...createSimpleProperty('pl')
        },
        margin: {
            label: 'Margin',
            type: 'select',
            options: ['auto', '0', 'px', '0.5', '1', '1.5', '2', '2.5', '3', '3.5', '4', '5', '6', '7', '8', '9', '10', '11', '12', '14', '16', '20', '24', '28', '32', '36', '40', '44', '48', '52', '56', '60', '64', '72', '80', '96'],
            default: '0',
            ...createSimpleProperty('m')
        },
        marginX: {
            label: 'Margin X',
            type: 'select',
            options: ['auto', '0', 'px', '0.5', '1', '1.5', '2', '2.5', '3', '3.5', '4', '5', '6', '7', '8', '9', '10', '11', '12', '14', '16', '20', '24', '28', '32', '36', '40', '44', '48', '52', '56', '60', '64', '72', '80', '96'],
            default: null,
            ...createSimpleProperty('mx')
        },
        marginY: {
            label: 'Margin Y',
            type: 'select',
            options: ['auto', '0', 'px', '0.5', '1', '1.5', '2', '2.5', '3', '3.5', '4', '5', '6', '7', '8', '9', '10', '11', '12', '14', '16', '20', '24', '28', '32', '36', '40', '44', '48', '52', '56', '60', '64', '72', '80', '96'],
            default: null,
            ...createSimpleProperty('my')
        },
        marginTop: {
            label: 'Margin Top',
            type: 'select',
            options: ['auto', '0', 'px', '0.5', '1', '1.5', '2', '2.5', '3', '3.5', '4', '5', '6', '7', '8', '9', '10', '11', '12', '14', '16', '20', '24', '28', '32', '36', '40', '44', '48', '52', '56', '60', '64', '72', '80', '96'],
            default: null,
            ...createSimpleProperty('mt')
        },
        marginRight: {
            label: 'Margin Right',
            type: 'select',
            options: ['auto', '0', 'px', '0.5', '1', '1.5', '2', '2.5', '3', '3.5', '4', '5', '6', '7', '8', '9', '10', '11', '12', '14', '16', '20', '24', '28', '32', '36', '40', '44', '48', '52', '56', '60', '64', '72', '80', '96'],
            default: null,
            ...createSimpleProperty('mr')
        },
        marginBottom: {
            label: 'Margin Bottom',
            type: 'select',
            options: ['auto', '0', 'px', '0.5', '1', '1.5', '2', '2.5', '3', '3.5', '4', '5', '6', '7', '8', '9', '10', '11', '12', '14', '16', '20', '24', '28', '32', '36', '40', '44', '48', '52', '56', '60', '64', '72', '80', '96'],
            default: null,
            ...createSimpleProperty('mb')
        },
        marginLeft: {
            label: 'Margin Left',
            type: 'select',
            options: ['auto', '0', 'px', '0.5', '1', '1.5', '2', '2.5', '3', '3.5', '4', '5', '6', '7', '8', '9', '10', '11', '12', '14', '16', '20', '24', '28', '32', '36', '40', '44', '48', '52', '56', '60', '64', '72', '80', '96'],
            default: null,
            ...createSimpleProperty('ml')
        },
        spaceX: {
            label: 'Space X',
            type: 'select',
            options: ['0', 'px', '0.5', '1', '1.5', '2', '2.5', '3', '3.5', '4', '5', '6', '7', '8', '9', '10', '11', '12', '14', '16', '20', '24', '28', '32', '36', '40', '44', '48', '52', '56', '60', '64', '72', '80', '96'],
            default: null,
            ...createSimpleProperty('space-x')
        },
        spaceY: {
            label: 'Space Y',
            type: 'select',
            options: ['0', 'px', '0.5', '1', '1.5', '2', '2.5', '3', '3.5', '4', '5', '6', '7', '8', '9', '10', '11', '12', '14', '16', '20', '24', '28', '32', '36', '40', '44', '48', '52', '56', '60', '64', '72', '80', '96'],
            default: null,
            ...createSimpleProperty('space-y')
        }
    }
};
